import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  orderBy,
  collection,
  updateDoc,
  increment,
} from "firebase/firestore";

import { db } from "../firebase";
import Cookies from "js-cookie";

export const Savesubscriber = async (data) => {
  const guid = Cookies.get("guid");

  const subQuery = query(
    collection(db, "subscriber"),
    where("userguid", "==", data.userguid),
    where("guid", "==", guid)
  );

  try {
    const subscriberSnapshot = await getDocs(subQuery);
    const userRef = doc(db, "users", data.userguid);

    if (!subscriberSnapshot.empty) {
      // Unsubscribe logic
      const existingDoc = subscriberSnapshot.docs[0];
      await deleteDoc(doc(db, "subscriber", existingDoc.id));
      await updateDoc(userRef, {
        subscriber: increment(-1),
      });
      return { success: true, removed: true };
    } else {
      // Subscribe logic
      const newDocRef = doc(db, "subscriber", data.uid); // ✅ Fixed
      const savequery = {
        ...data,
        latitude: Cookies.get("latitude") || "",
        longitude: Cookies.get("longitude") || "",
        city: Cookies.get("City") || "",
        postcode: Cookies.get("Postcode") || "",
        state: Cookies.get("State") || "",
        Country: Cookies.get("Country") || "",
        guid: guid,
        date_time: new Date(),
        device: navigator.userAgent || "",
        ip: Cookies.get("ipaddress") || "",
        status: true,
        public: false,
      };

      await setDoc(newDocRef, savequery);
      await updateDoc(userRef, {
        subscriber: increment(1),
      });

      return { success: true, saved: true };
    }
  } catch (err) {
    console.error("Error saving/removing subscriber:", err);
    return { success: false, error: err.message };
  }
};
